(function () {
  if (!window.klettConfig && !window.schrumpfConfig) return;

  function getLengthFromText(text) {
    const match = String(text || '').match(/(\d+(?:[.,]\d+)?)/);
    return match ? parseFloat(match[1].replace(',', '.')) : null;
  }

  function getNumber(value) {
    return parseFloat(String(value || '').replace(',', '.'));
  }

  function getCurrentVariantId() {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return urlVariant;

    const formVariant = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    if (formVariant) return formVariant;

    const variants = window.klettConfig?.variants || [];
    return variants.find(v => v.available)?.id || variants?.[0]?.id;
  }

  function getSelectedVariant() {
    const variantId = getCurrentVariantId();
    const variants = window.klettConfig?.variants || [];
    return variants.find(v => String(v.id) === String(variantId));
  }

  function berechneBuendelDurchmesser(kabellaenge, kabeldurchmesser) {
    const e16 = kabellaenge / 0.7;
    const faktor = (-0.00174 * Math.pow(e16, 2)) + (0.23575 * e16) + 1.3611;
    return faktor * kabeldurchmesser;
  }

  function getKlettForVariant() {
    if (!window.klettConfig) return null;

    const selectedVariant = getSelectedVariant();
    if (!selectedVariant) return null;

    const variantText = selectedVariant.public_title || selectedVariant.title;
    const kabellaenge = getLengthFromText(variantText);
    const metafeldDurchmesser = getNumber(window.klettConfig.klettberechnung);

    const kabeldurchmesser = metafeldDurchmesser > 0
      ? metafeldDurchmesser
      : getNumber(window.klettConfig.kabeldurchmesser);

    if (!kabellaenge || !kabeldurchmesser) return null;
    if (kabellaenge > 50) return null;

    const buendelDurchmesser = berechneBuendelDurchmesser(kabellaenge, kabeldurchmesser);

    return window.klettConfig.mapping.find(
      item => item.buendelbarerDurchmesser > buendelDurchmesser
    ) || null;
  }

  function getSchrumpfForProduct() {
    if (!window.schrumpfConfig) return null;

    const kabeldurchmesser = getNumber(window.schrumpfConfig.kabeldurchmesser);
    if (!kabeldurchmesser) return null;

    return window.schrumpfConfig.mapping.find(
      item => kabeldurchmesser <= item.maxDurchmesser
    ) || null;
  }

  async function loadVariantData(item) {
    if (!item || item.price) return item;

    const response = await fetch(`/variants/${item.variantId}.js`);
    const variant = await response.json();

    item.price = variant.price;
    item.title = variant.name || variant.title;
    item.priceText = (variant.price / 100)
      .toFixed(2)
      .replace('.', ',') + ' €';

    return item;
  }

  function getPriceText(item) {
    const brutto = item.price / 100;
    const netto = brutto / 1.19;
    const nettoText = netto.toFixed(2).replace('.', ',');

    return `(+ ${item.priceText} / Stück <small>(${nettoText} € netto)</small>)`;
  }

async function updateKlettPrice() {
  const priceEl = document.querySelector('#klett-price');
  const labelEl = document.querySelector('#klett-label');
  const checkboxEl = document.querySelector('#add-klett');

  if (!priceEl || !window.klettConfig) return;

  const klett = getKlettForVariant();

  // Klett-Option einschließlich Checkbox ausblenden,
  // wenn kein passendes Klett verfügbar ist
  if (!klett) {
    priceEl.textContent = '';
    if (labelEl) labelEl.textContent = '';

    if (checkboxEl) {
      const container = checkboxEl.closest('label') || checkboxEl.parentElement;
      if (container) container.style.display = 'none';
    }

    return;
  }

  // Klett-Option wieder einblenden, wenn sie verfügbar ist
  if (checkboxEl) {
    const container = checkboxEl.closest('label') || checkboxEl.parentElement;
    if (container) container.style.display = '';
  }

  await loadVariantData(klett);

  if (labelEl && klett.title) {
    labelEl.textContent = `${klett.title}`;
  }

  priceEl.innerHTML = getPriceText(klett);
}

async function updateSchrumpfPrice() {
  const priceEl = document.querySelector('#schrumpf-price');
  const labelEl = document.querySelector('#schrumpf-label');
  const checkboxEl = document.querySelector('#add-schrumpf');

  if (!priceEl || !window.schrumpfConfig) return;

  const schrumpf = getSchrumpfForProduct();

  // Schrumpfschlauch ausblenden, wenn kein passender verfügbar ist
  if (!schrumpf) {
    priceEl.textContent = '';
    if (labelEl) labelEl.textContent = '';

    if (checkboxEl) {
      const container = checkboxEl.closest('label') || checkboxEl.parentElement;
      if (container) container.style.display = 'none';
    }

    return;
  }

  // Schrumpfschlauch wieder einblenden, wenn verfügbar
  if (checkboxEl) {
    const container = checkboxEl.closest('label') || checkboxEl.parentElement;
    if (container) container.style.display = '';
  }

  await loadVariantData(schrumpf);

  if (labelEl && schrumpf.title) {
    labelEl.textContent = `${schrumpf.title}`;
  }

  priceEl.innerHTML = getPriceText(schrumpf);
}

// updatePrices MUSS AUSSERHALB beider Funktionen stehen

function updatePrices() {

  if (window.klettConfig) updateKlettPrice();

  if (window.schrumpfConfig) updateSchrumpfPrice();

}

document.addEventListener('DOMContentLoaded', function () {

  updatePrices();

  let lastVariantId = getCurrentVariantId();

  setInterval(function () {

    const currentVariantId = getCurrentVariantId();

    if (currentVariantId && String(currentVariantId) !== String(lastVariantId)) {

      lastVariantId = currentVariantId;

      updatePrices();

    }

  }, 200);

});

  document.addEventListener('DOMContentLoaded', function () {
    updatePrices();

    let lastVariantId = getCurrentVariantId();

    setInterval(function () {
      const currentVariantId = getCurrentVariantId();

      if (currentVariantId && String(currentVariantId) !== String(lastVariantId)) {
        lastVariantId = currentVariantId;
        updatePrices();
      }
    }, 200);
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    const addKlett = document.querySelector('#add-klett')?.checked;
    const addSchrumpf = document.querySelector('#add-schrumpf')?.checked;

    if (!addKlett && !addSchrumpf) return;

    const formData = new FormData(form);
    const quantity = parseInt(formData.get('quantity') || 1, 10);
    const cableVariantId = getCurrentVariantId();
    const selectedVariant = getSelectedVariant();

    if (!cableVariantId) return;

    const items = [{ id: Number(cableVariantId), quantity }];

    if (addKlett && selectedVariant) {
      const klett = getKlettForVariant();

      if (klett) {
        items.push({
          id: Number(klett.variantId),
          quantity,
          properties: {
            "Für Kabel":
              window.klettConfig.productTitle +
              " - " +
              (selectedVariant.public_title || selectedVariant.title)
          }
        });
      }
    }

    if (addSchrumpf) {
      const schrumpf = getSchrumpfForProduct();

      if (schrumpf) {
        items.push({
          id: Number(schrumpf.variantId),
          quantity,
          properties: {
            "Für Kabel": window.schrumpfConfig.productTitle,
            "_Kabeldurchmesser":
              String(window.schrumpfConfig.kabeldurchmesser) + " mm"
          }
        });
      }
    }

    if (items.length <= 1) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const headerSection = document.querySelector(
      'header[id^="shopify-section-"][id*="__header_section"]'
    );

    const sectionId = headerSection
      ? headerSection.id.replace('shopify-section-', '')
      : null;

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items,
        sections: sectionId ? [sectionId] : undefined,
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (sectionId && data.sections?.[sectionId]) {
      const newHeader = new DOMParser()
        .parseFromString(data.sections[sectionId], 'text/html')
        .querySelector(`#shopify-section-${CSS.escape(sectionId)}`);

      if (newHeader && headerSection) {
        headerSection.replaceWith(newHeader);
      }
    }
  }, true);
})();